export default "__VITE_PUBLIC_ASSET__6957903e__"